import { Box, ColorOptions, SpacerNew, Text } from '@jfs/ui-new'
import { ButtonNew } from '../AdminButton'
import { isEmpty } from '@jfs/utils'
import { useState } from 'react'
import { formatDate } from '../../utils'

const inputBoxConfig = {
  element: document.createElement('input'),
  type: 'file',
}

const setValue = (e: any) => {
  if (e) {
    e.value = ''
  }
}

interface FileSelectorProps {
  onPress: any
  isLoading: boolean
  readFile?: any
  fileType?: string
  isValidFile?: boolean
}

const FileSelector = ({ onPress, isLoading, readFile, fileType = '', isValidFile = true }: FileSelectorProps) => {
  const [file, setFile] = useState<File>()
  const handlePress = (): void => {
    const inputBox = inputBoxConfig.element
    inputBox.type = inputBoxConfig.type
    inputBox.draggable = true
    if (!isEmpty(fileType)) {
      inputBox.accept = fileType
    }
    inputBox.click()
    inputBox.onchange = (e: Event): void => {
      const target = e.target as HTMLInputElement
      const fileIn = (target.files as FileList)[0]
      if (fileIn) {
        setFile(fileIn)
        readFile && readFile(fileIn)
      }
      setValue(e.target)
    }
  }

  const handleUpload = () => onPress(file)
  const reset = () => {
    readFile && readFile(undefined)
    setFile(undefined)
  }
  const showFileSelectView = !!file && isValidFile
  return (
    <>
      {!showFileSelectView && (
        <Box flexDirection={'row'} pt={8} align={'center'}>
          <ButtonNew
            title={'Choose File'}
            onPress={handlePress}
            height={30}
            borderRadius={2}
            hoverColor={'LIGHTEST_GREY'}
            borderWidth={1}
            borderColor={'BLACK_21'}
            titleColor={'BLACK_21'}
            color={'LIGHTEST_GREY'}
          />
          <SpacerNew direction={'horizontal'} size={4} />
          <Text
            title={'No file chosen'}
            color={'#858796' as ColorOptions}
            fontSize={16}
            fontFamily={'jiotype-medium'}
          />
        </Box>
      )}
      {showFileSelectView && (
        <Box>
          <SpacerNew direction={'vertical'} size={16} />
          <Text
            title={`Filename: ${file?.name}`}
            color={'#858796' as ColorOptions}
            fontSize={16}
            fontFamily={'jiotype-medium'}
          />
          <SpacerNew direction={'vertical'} size={16} />
          <Text
            title={`Size in bytes: ${file?.size}`}
            color={'#858796' as ColorOptions}
            fontSize={16}
            fontFamily={'jiotype-medium'}
          />
          <SpacerNew direction={'vertical'} size={16} />
          <Text
            title={`Last Modified Date: ${formatDate(file.lastModified)}`}
            color={'#858796' as ColorOptions}
            fontSize={16}
            fontFamily={'jiotype-medium'}
          />
          <SpacerNew direction={'vertical'} size={24} />
          <Box flexDirection={'row'}>
            <ButtonNew title={'Reset'} onPress={reset} height={38} color={'#4373df' as ColorOptions} borderRadius={4} />
            <SpacerNew direction={'horizontal'} size={16} />
            <ButtonNew
              title="Upload"
              onPress={handleUpload}
              height={38}
              color={'#4373df' as ColorOptions}
              borderRadius={4}
              isLoading={isLoading}
              width={80}
            />
          </Box>
        </Box>
      )}
    </>
  )
}

export { FileSelector }
